export default __webpack_public_path__ + "fonts/AzeretMono-SemiBold.ttf";